var _rect, _rect2, _rect3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconeAdicionarEscuro = function SvgIconeAdicionarEscuro(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.78125,
    width: 16.125,
    height: 17.125,
    rx: 4,
    fill: "#004379"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.71954,
    y: 4.71875,
    width: 1.93605,
    height: 9.25,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.3125,
    y: 8.37598,
    width: 1.93605,
    height: 9.25,
    transform: "rotate(90 13.3125 8.37598)",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconeAdicionarEscuro, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone_adicionar_escuro.40206e74.svg";
export { ForwardRef as ReactComponent };